import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { StepConnector } from '@mui/material'
import { withStyles } from '@mui/styles'
import { colors } from '@global/constants'

export const CustomStepConnector = withStyles(theme => ({
  active: {
    '& $line': {
      backgroundImage: `linear-gradient(95deg, ${theme.palette.secondary.main} 0%, ${theme.palette.primary.main} 100%)`,
    },
  },
  completed: {
    '& $line': {
      backgroundColor: `${theme.palette.secondary.main}`,
    },
  },
  line: {
    backgroundColor: colors.gray.light,
    height: 2,
    border: 0,
  },
}))(StepConnector)

export const Timestamp = styled.div`
  margin-top: 4px;
  font-style: italic;
  font-size: 11px;
  color: ${colors.gray.medium};
`

export const StepperContainer = styled.div`
  width: 100%;
  min-width: 540px;
  padding: 0;
`

export const stepper = css`
  padding: 0;
`
